import React, { useState, useEffect } from "react";
import Quill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";

import "../../css/post-job.css";
import DashboardLayout from "./DashboardLayout";

const jobModeOptions = ["Remote", "Onsite", "Hybrid"];

// Countries/Regions with flags
const locationOptions = [
  { name: "India", flag: "🇮🇳", type: "country" },
  { name: "UAE", flag: "🇦🇪", type: "country" },
  { name: "Singapore", flag: "🇸🇬", type: "country" },
  { name: "Australia", flag: "🇦🇺", type: "country" },
  { name: "New Zealand", flag: "🇳🇿", type: "country" },
  { name: "United Kingdom", flag: "🇬🇧", type: "country" },
  { name: "Europe", flag: "🇪🇺", type: "region" },
  { name: "Japan", flag: "🇯🇵", type: "country" },
  { name: "United States", flag: "🇺🇸", type: "country" },
  { name: "Canada", flag: "🇨🇦", type: "country" },
  { name: "South Africa", flag: "🇿🇦", type: "country" },
  { name: "Africa", flag: "🌍", type: "region" },
  { name: "Saudi Arabia", flag: "🇸🇦", type: "country" },
  { name: "Oman", flag: "🇴🇲", type: "country" },
  { name: "Qatar", flag: "🇶🇦", type: "country" },
  { name: "Bahrain", flag: "🇧🇭", type: "country" },
  { name: "Others", flag: "🌐", type: "other" },
];

// State/Province options based on location
const stateOptions = {
  India: [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Puducherry",
    "Chandigarh",
    "Andaman and Nicobar Islands",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Lakshadweep",
  ],
  UAE: [
    "Abu Dhabi",
    "Dubai",
    "Sharjah",
    "Ajman",
    "Fujairah",
    "Ras Al Khaimah",
    "Umm Al Quwain",
  ],
  "United States": [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ],
  Canada: [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Northwest Territories",
    "Nova Scotia",
    "Nunavut",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Yukon",
  ],
  Australia: [
    "New South Wales",
    "Victoria",
    "Queensland",
    "Western Australia",
    "South Australia",
    "Tasmania",
    "Australian Capital Territory",
    "Northern Territory",
  ],
  "United Kingdom": ["England", "Scotland", "Wales", "Northern Ireland"],
  Europe: [
    "🇦🇹 Austria",
    "🇧🇪 Belgium",
    "🇧🇬 Bulgaria",
    "🇭🇷 Croatia",
    "🇨🇾 Cyprus",
    "🇨🇿 Czech Republic",
    "🇩🇰 Denmark",
    "🇪🇪 Estonia",
    "🇫🇮 Finland",
    "🇫🇷 France",
    "🇩🇪 Germany",
    "🇬🇷 Greece",
    "🇭🇺 Hungary",
    "🇮🇪 Ireland",
    "🇮🇹 Italy",
    "🇱🇻 Latvia",
    "🇱🇹 Lithuania",
    "🇱🇺 Luxembourg",
    "🇲🇹 Malta",
    "🇳🇱 Netherlands",
    "🇳🇴 Norway",
    "🇵🇱 Poland",
    "🇵🇹 Portugal",
    "🇷🇴 Romania",
    "🇸🇰 Slovakia",
    "🇸🇮 Slovenia",
    "🇪🇸 Spain",
    "🇸🇪 Sweden",
    "🇨🇭 Switzerland",
  ],
  Africa: [
    "🇩🇿 Algeria",
    "🇦🇴 Angola",
    "🇧🇼 Botswana",
    "🇧🇫 Burkina Faso",
    "🇨🇲 Cameroon",
    "🇹🇩 Chad",
    "🇪🇬 Egypt",
    "🇪🇹 Ethiopia",
    "🇬🇭 Ghana",
    "🇨🇮 Ivory Coast",
    "🇰🇪 Kenya",
    "🇱🇾 Libya",
    "🇲🇬 Madagascar",
    "🇲🇱 Mali",
    "🇲🇦 Morocco",
    "🇲🇿 Mozambique",
    "🇳🇦 Namibia",
    "🇳🇪 Niger",
    "🇳🇬 Nigeria",
    "🇷🇼 Rwanda",
    "🇸🇳 Senegal",
    "🇿🇦 South Africa",
    "🇸🇩 Sudan",
    "🇹🇿 Tanzania",
    "🇹🇳 Tunisia",
    "🇺🇬 Uganda",
    "🇿🇲 Zambia",
    "🇿🇼 Zimbabwe",
  ],
  "Saudi Arabia": [
    "Riyadh",
    "Makkah",
    "Madinah",
    "Eastern Province",
    "Asir",
    "Tabuk",
    "Qassim",
    "Ha'il",
    "Jazan",
    "Najran",
    "Al Bahah",
    "Northern Borders",
    "Al Jawf",
  ],
  Japan: [
    "Tokyo",
    "Osaka",
    "Kyoto",
    "Hokkaido",
    "Fukuoka",
    "Yokohama",
    "Nagoya",
    "Sapporo",
    "Kobe",
    "Kawasaki",
    "Saitama",
    "Hiroshima",
    "Sendai",
    "Chiba",
    "Kitakyushu",
  ],
};

const skillOptions = [
  "Human Resources",
  "Recruitment",
  "Employee Relations",
  "Payroll",
  "Training and Development",
  "Compliance",
  "Finance",
  "Financial Analysis",
  "Budgeting",
  "Accounting",
  "Auditing",
  "Financial Reporting",
  "Marketing",
  "SEO",
  "Content Marketing",
  "Social Media Marketing",
  "Email Marketing",
  "PPC",
  "Branding",
  "Sales",
  "Lead Generation",
  "CRM",
  "Negotiation",
  "Sales Strategy",
  "Customer Relationship Management",
  "Information Technology (IT)",
  "Network Administration",
  "Cybersecurity",
  "Software Development",
  "Database Management",
  "Technical Support",
  "Customer Service",
  "Communication",
  "Problem-Solving",
  "CRM",
  "Conflict Resolution",
  "Customer Support",
  "Operations",
  "Process Improvement",
  "Supply Chain Management",
  "Inventory Management",
  "Operations Strategy",
  "Logistics",
  "Research and Development (R&D)",
  "Product Development",
  "Market Research",
  "Innovation",
  "Data Analysis",
  "Project Management",
  "Product Management",
  "Product Strategy",
  "Market Analysis",
  "Agile Methodology",
  "Product Lifecycle Management",
  "Roadmapping",
  "Engineering",
  "Mechanical Engineering",
  "Electrical Engineering",
  "Civil Engineering",
  "Quality Control",
  "Project Management",
  "Supply Chain Management",
  "Procurement",
  "Logistics",
  "Supplier Management",
  "Demand Planning",
  "Inventory Control",
  "Logistics",
  "Telecommunication",
  "Transportation Management",
  "Warehouse Management",
  "Distribution Planning",
  "Supply Chain Coordination",
  "Legal",
  "Contract Law",
  "Compliance",
  "Intellectual Property",
  "Litigation",
  "Corporate Law",
  "Public Relations (PR)",
  "Media Relations",
  "Press Release Writing",
  "Crisis Management",
  "Event Planning",
  "Communications",
  "Quality Assurance (QA)",
  "Quality Control",
  "Testing",
  "Compliance",
  "Auditing",
  "Process Improvement",
  "Administration",
  "Office Management",
  "Scheduling",
  "Administrative Support",
  "Document Management",
  "Communication",
  "Design",
  "Graphic Design",
  "UX/UI Design",
  "Visual Communication",
  "Adobe Creative Suite",
  "Prototyping",
  "Project Management",
  "Project Planning",
  "Risk Management",
  "Stakeholder Communication",
  "Budgeting",
  "Agile Methodology",
  "Compliance",
  "Regulatory Knowledge",
  "Risk Assessment",
  "Auditing",
  "Policy Development",
  "Reporting",
  "Training and Development",
  "Training Program Design",
  "Instructional Design",
  "E-learning",
  "Coaching",
].sort();
//as
const experienceOptions = [
  "Fresher",
  "Early Professional",
  "Mid Level",
  "Senior",
  "Super Senior",
];

const jobTypeOptions = [
  "Full Time",
  "Part Time",
  "Contract",
  "Consultant",
  "Freelancer",
  "Internship",
];

const departmentOptions = [
  "Human Resources",
  "Finance",
  "Marketing",
  "Sales",
  "Information Technology (IT)",
  "Customer Service",
  "Operations",
  "Research and Development (R&D)",
  "Product Management",
  "Engineering",
  "Supply Chain Management",
  "Logistics",
  "Legal",
  "Public Relations (PR)",
  "Quality Assurance (QA)",
  "Administration",
  "Design",
  "Project Management",
  "Compliance",
  "Training and Development",
];

const PostJob = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [location, setLocation] = useState("");
  const [experience, setExperience] = useState("");
  const [skillset, setSkillset] = useState("");
  const [jobType, setJobType] = useState("");
  const [department, setDepartment] = useState("");
  const [jobMode, setJobMode] = useState("");
  const [state, setState] = useState("");
  const [priority, setPriority] = useState(false);
  const [numberOfOpenings, setNumberOfOpenings] = useState(1);
  const [tags, setTags] = useState([]);
  const [currentTag, setCurrentTag] = useState("");
  const [assignedEmployee, setAssignedEmployee] = useState("");
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [availableStates, setAvailableStates] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_BASEURL}/api/employee/getAllEmployees`,
          { withCredentials: true }
        );
        setEmployees(res.data.data);
      } catch (err) {
        console.error("Error fetching employees:", err);
      }
    };
    fetchEmployees();
  }, []);

  // Handle location change and update available states
  const handleLocationChange = (selectedLocation) => {
    setLocation(selectedLocation);
    setState(""); // Reset state when location changes

    if (stateOptions[selectedLocation]) {
      setAvailableStates(stateOptions[selectedLocation]);
    } else {
      setAvailableStates([]);
    }
  };

  const handleAddTag = (e) => {
    // Add tag when Enter or Comma is pressed
    if (
      (e.key === "Enter" || e.key === ",") &&
      currentTag.trim() &&
      tags.length < 5
    ) {
      e.preventDefault();
      const newTag = currentTag.trim();
      if (!tags.includes(newTag)) {
        setTags([...tags, newTag]);
        setCurrentTag("");
      }
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const validateForm = () => {
    const errors = {};

    if (!title.trim()) errors.title = "Job title is required";
    if (!description.trim()) errors.description = "Job description is required";
    if (!location) errors.location = "Location is required";
    if (!experience) errors.experience = "Experience level is required";
    if (!skillset) errors.skillset = "Skillset is required";
    if (!jobType) errors.jobType = "Job type is required";
    if (!department) errors.department = "Department is required";
    if (!jobMode) errors.jobMode = "Job mode is required";
    if (numberOfOpenings < 1)
      errors.numberOfOpenings = "At least one opening is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePostJob = async () => {
    if (!validateForm()) {
      window.scrollTo(0, 0);
      return;
    }

    setLoading(true);
    const assignedEmployeeObj = employees.find(
      (emp) => emp.email === assignedEmployee
    );

    const jobData = {
      title,
      description,
      location,
      experience,
      skillset,
      jobType,
      department,
      jobMode,
      state,
      priority,
      numberOfOpenings,
      tags,
      assignedEmployee: assignedEmployeeObj ? assignedEmployeeObj._id : null,
    };

    try {
      console.log(jobData);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_BASEURL}/api/post-job`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(jobData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Show success message
        const successMessage = document.getElementById("success-message");
        successMessage.classList.add("visible");
        setTimeout(() => {
          successMessage.classList.remove("visible");
        }, 3000);

        // Reset form
        setTitle("");
        setDescription("");
        setLocation("");
        setExperience("");
        setSkillset("");
        setJobType("");
        setAssignedEmployee("");
        setDepartment("");
        setFormErrors({});
      } else {
        // Show error message
        const errorMessage = document.getElementById("error-message");
        errorMessage.textContent = data.message || "Failed to post job.";
        errorMessage.classList.add("visible");
        setTimeout(() => {
          errorMessage.classList.remove("visible");
        }, 3000);
      }
    } catch (error) {
      console.error("Error posting job:", error);
      const errorMessage = document.getElementById("error-message");
      errorMessage.textContent = "An error occurred. Please try again.";
      errorMessage.classList.add("visible");
      setTimeout(() => {
        errorMessage.classList.remove("visible");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="post-job-container">
        <div id="success-message" className="notification success">
          🎉 Job posted successfully!
        </div>
        <div id="error-message" className="notification error">
          Error posting job.
        </div>

        <div className="post-job-card">
          <div className="post-job-header">
            <h2 className="post-job-heading">Post a New Job</h2>
            <p className="post-job-subheading">
              Complete all fields to create your job listing
            </p>
          </div>

          <div className="form-section">
            <h3 className="section-title">Basic Information</h3>

            <div className="form-group">
              <label htmlFor="job-title">
                Job Title <span className="required">*</span>
              </label>
              <input
                id="job-title"
                type="text"
                className={`job-input ${formErrors.title ? "error" : ""}`}
                placeholder="e.g. Senior Frontend Developer"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              {formErrors.title && (
                <span className="error-text">{formErrors.title}</span>
              )}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="job-location">
                  Location <span className="required">*</span>
                </label>
                <select
                  id="job-location"
                  className={`job-select ${formErrors.location ? "error" : ""}`}
                  value={location}
                  onChange={(e) => handleLocationChange(e.target.value)}
                >
                  <option value="">Select a location</option>
                  {locationOptions.map((location, index) => (
                    <option key={index} value={location.name}>
                      {location.flag} {location.name}
                    </option>
                  ))}
                </select>
                {formErrors.location && (
                  <span className="error-text">{formErrors.location}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="job-type">
                  Job Type <span className="required">*</span>
                </label>
                <select
                  id="job-type"
                  className={`job-select ${formErrors.jobType ? "error" : ""}`}
                  value={jobType}
                  onChange={(e) => setJobType(e.target.value)}
                >
                  <option value="">Select job type</option>
                  {jobTypeOptions.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {formErrors.jobType && (
                  <span className="error-text">{formErrors.jobType}</span>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="job-mode">
                  Job Mode <span className="required">*</span>
                </label>
                <select
                  id="job-mode"
                  className={`job-select ${formErrors.jobMode ? "error" : ""}`}
                  value={jobMode}
                  onChange={(e) => setJobMode(e.target.value)}
                >
                  <option value="">Select job mode</option>
                  {jobModeOptions.map((mode, index) => (
                    <option key={index} value={mode}>
                      {mode}
                    </option>
                  ))}
                </select>
                {formErrors.jobMode && (
                  <span className="error-text">{formErrors.jobMode}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="state">
                  {location === "Europe"
                    ? "Country"
                    : location === "Africa"
                    ? "Country"
                    : location === "India"
                    ? "State"
                    : location === "United States"
                    ? "State"
                    : location === "Canada"
                    ? "Province"
                    : location === "Australia"
                    ? "State"
                    : location === "UAE"
                    ? "Emirate"
                    : location === "Saudi Arabia"
                    ? "Province"
                    : location === "Japan"
                    ? "Prefecture"
                    : location === "United Kingdom"
                    ? "Country"
                    : "State/Province"}{" "}
                  {availableStates.length > 0 ? "*" : "(Optional)"}
                </label>
                {availableStates.length > 0 ? (
                  <select
                    id="state"
                    className="job-select"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  >
                    <option value="">
                      Select{" "}
                      {location === "Europe" || location === "Africa"
                        ? "country"
                        : location === "India" ||
                          location === "United States" ||
                          location === "Australia"
                        ? "state"
                        : location === "Canada"
                        ? "province"
                        : location === "UAE"
                        ? "emirate"
                        : location === "Saudi Arabia"
                        ? "province"
                        : location === "Japan"
                        ? "prefecture"
                        : location === "United Kingdom"
                        ? "country"
                        : "state/province"}
                    </option>
                    {availableStates.map((stateOption, index) => (
                      <option key={index} value={stateOption}>
                        {stateOption}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id="state"
                    type="text"
                    className="job-input"
                    placeholder="Enter state/province"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="number-of-openings">
                  Number of Openings <span className="required">*</span>
                </label>
                <input
                  id="number-of-openings"
                  type="number"
                  min="1"
                  className={`job-input ${
                    formErrors.numberOfOpenings ? "error" : ""
                  }`}
                  value={numberOfOpenings}
                  onChange={(e) =>
                    setNumberOfOpenings(parseInt(e.target.value))
                  }
                />
                {formErrors.numberOfOpenings && (
                  <span className="error-text">
                    {formErrors.numberOfOpenings}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="priority">Priority</label>
                <div className="checkbox-container">
                  <input
                    id="priority"
                    type="checkbox"
                    checked={priority}
                    onChange={(e) => setPriority(e.target.checked)}
                  />
                  <span>Mark as High Priority</span>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="tags">Tags (Max 5)</label>
              <div className="tags-container">
                <div className="tags-input-wrapper">
                  {tags.map((tag, index) => (
                    <span key={index} className="tag">
                      {tag}
                      <button
                        type="button"
                        className="tag-remove"
                        onClick={() => handleRemoveTag(tag)}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                  <input
                    type="text"
                    placeholder="Add tags (Press Enter or , to add)"
                    value={currentTag}
                    onChange={(e) => setCurrentTag(e.target.value)}
                    onKeyDown={handleAddTag}
                    disabled={tags.length >= 5}
                  />
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="department">
                  Department <span className="required">*</span>
                </label>
                <select
                  id="department"
                  className={`job-select ${
                    formErrors.department ? "error" : ""
                  }`}
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                >
                  <option value="">Select department</option>
                  {departmentOptions.map((dept, index) => (
                    <option key={index} value={dept}>
                      {dept}
                    </option>
                  ))}
                </select>
                {formErrors.department && (
                  <span className="error-text">{formErrors.department}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="experience">
                  Experience Level <span className="required">*</span>
                </label>
                <select
                  id="experience"
                  className={`job-select ${
                    formErrors.experience ? "error" : ""
                  }`}
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                >
                  <option value="">Select experience level</option>
                  {experienceOptions.map((exp, index) => (
                    <option key={index} value={exp}>
                      {exp}
                    </option>
                  ))}
                </select>
                {formErrors.experience && (
                  <span className="error-text">{formErrors.experience}</span>
                )}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="skillset">
                Required Skills <span className="required">*</span>
              </label>
              <select
                id="skillset"
                className={`job-select ${formErrors.skillset ? "error" : ""}`}
                value={skillset}
                onChange={(e) => setSkillset(e.target.value)}
              >
                <option value="">Select primary skillset</option>
                {skillOptions.map((skill, index) => (
                  <option key={index} value={skill}>
                    {skill}
                  </option>
                ))}
              </select>
              {formErrors.skillset && (
                <span className="error-text">{formErrors.skillset}</span>
              )}
            </div>
          </div>
          {employees.length > 0 && (
            <div className="form-section">
              <h3 className="section-title">Assignment</h3>
              <div className="form-group">
                <label htmlFor="assign-employee">
                  Assign to Employee (Optional)
                </label>
                <select
                  id="assign-employee"
                  className="job-select"
                  value={assignedEmployee}
                  onChange={(e) => setAssignedEmployee(e.target.value)}
                >
                  <option value="">Select an employee to assign</option>
                  {employees.map((employee) => (
                    <option key={employee._id} value={employee.email}>
                      {employee.firstName} {employee.lastName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <div className="form-section">
            <h3 className="section-title">Job Description</h3>
            <p className="section-description">
              Provide a detailed description of the role, responsibilities, and
              requirements.
            </p>

            <div className="form-group">
              <label htmlFor="description">
                Description <span className="required">*</span>
              </label>
              <div
                className={`editor-container ${
                  formErrors.description ? "error" : ""
                }`}
              >
                <Quill
                  id="description"
                  className="job-description-editor"
                  theme="snow"
                  value={description}
                  onChange={setDescription}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["blockquote", "code-block"],
                      [{ align: [] }],
                      ["link"],
                      ["clean"],
                    ],
                  }}
                />
              </div>
              {formErrors.description && (
                <span className="error-text">{formErrors.description}</span>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button
              className="secondary-button"
              onClick={() => {
                if (
                  window.confirm("Are you sure you want to clear the form?")
                ) {
                  setTitle("");
                  setDescription("");
                  setLocation("");
                  setExperience("");
                  setSkillset("");
                  setJobType("");
                  setAssignedEmployee("");
                  setDepartment("");
                  setFormErrors({});
                }
              }}
              disabled={loading}
            >
              Clear Form
            </button>

            <button
              className="primary-button"
              onClick={handlePostJob}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Posting...
                </>
              ) : (
                "Post Job"
              )}
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PostJob;
